import NuxAccountBasicsList from 'app/common/react/components/growth/activation/NuxLocaleCountryStep/NuxAccountBasicsList';
import withResource from 'app/common/lib/react/withResource';

export default withResource({
  name: 'CountriesResource',
  key: 'items',
})(NuxAccountBasicsList);
